export enum ProviderIdentityTypeEnum {
    providerCode = 1,
    cpf = 2,
    cnpj = 3
}